document.querySelectorAll('.buy-product').forEach(productBlock => {
    const tubs = productBlock.querySelectorAll('.buy-product-tub');
    const btn = productBlock.querySelector('.buy-product-type__btn');
    const productTypes = productBlock.querySelectorAll('.buy-product-type');
    const trigger = productBlock.querySelector('.buy-product-type-select__trigger');
    const items = productBlock.querySelector('.buy-product-select-items');
    const selectItems = productBlock.querySelectorAll('.buy-product-select-item');
  
    // Конфиг всех данных
    const config = {
      1: {
        old: "$96.00", price: "$69.00",
        autoOld: "$96.00", autoPrice: "$58.00",
        saveOneTime: "save $27.00", saveSub: "save $58.00",
        listPrice: "$58.00",
        hrefOneTime: "https://ecowisevitamins.com/cart/clear?return_to=/cart/add?items[][id]=50164149748000%26items[][quantity]=1%26return_to=/checkout",
        hrefSub: {
          "Delivery every 1 month": "https://ecowisevitamins.com/cart/clear?return_to=/cart/add?items[][id]=50795719786784%26items[][quantity]=1%26items[][selling_plan]=5621547296%26items[][id]=50795724865824%26items[][quantity]=1%26return_to=/checkout",
          "Delivery every 2 months": "https://ecowisevitamins.com/cart/clear?return_to=/cart/add?items[][id]=50795719786784%26items[][quantity]=1%26items[][selling_plan]=5621580064%26items[][id]=50795724865824%26items[][quantity]=1%26return_to=/checkout",
          "Delivery every 3 months": "https://ecowisevitamins.com/cart/clear?return_to=/cart/add?items[][id]=50795719786784%26items[][quantity]=1%26items[][selling_plan]=5621612832%26items[][id]=50795724865824%26items[][quantity]=1%26return_to=/checkout"
        }
      },
      2: {
        old: "$166.00", price: "$113.00",
        autoOld: "$166.00", autoPrice: "$93.00",
        saveOneTime: "save $53.00", saveSub: "save $83.00",
        listPrice: "$93.00",
        hrefOneTime: "https://ecowisevitamins.com/cart/clear?return_to=/cart/add?items[][id]=50164149780768%26items[][quantity]=1%26return_to=/checkout",
        hrefSub: {
          "Delivery every 1 month": "https://ecowisevitamins.com/cart/clear?return_to=/cart/add?items[][id]=50795719819552%26items[][quantity]=1%26items[][selling_plan]=5621547296%26items[][id]=50795724865824%26items[][quantity]=1%26return_to=/checkout",
          "Delivery every 2 months": "https://ecowisevitamins.com/cart/clear?return_to=/cart/add?items[][id]=50795719819552%26items[][quantity]=1%26items[][selling_plan]=5621580064%26items[][id]=50795724865824%26items[][quantity]=1%26return_to=/checkout",
          "Delivery every 3 months": "https://ecowisevitamins.com/cart/clear?return_to=/cart/add?items[][id]=50795719819552%26items[][quantity]=1%26items[][selling_plan]=5621612832%26items[][id]=50795724865824%26items[][quantity]=1%26return_to=/checkout"
        }
      },
      3: {
        old: "$236.00", price: "$145.00",
        autoOld: "$236.00", autoPrice: "$128.00",
        saveOneTime: "save $91.00", saveSub: "save $118.00",
        listPrice: "$128.00",
        hrefOneTime: "https://ecowisevitamins.com/cart/clear?return_to=/cart/add?items[][id]=50164149813536%26items[][quantity]=1%26return_to=/checkout",
        hrefSub: {
          "Delivery every 1 month": "https://ecowisevitamins.com/cart/clear?return_to=/cart/add?items[][id]=50795719852320%26items[][quantity]=1%26items[][selling_plan]=5621547296%26items[][id]=50795724865824%26items[][quantity]=1%26return_to=/checkout",
          "Delivery every 2 months": "https://ecowisevitamins.com/cart/clear?return_to=/cart/add?items[][id]=50795719852320%26items[][quantity]=1%26items[][selling_plan]=5621580064%26items[][id]=50795724865824%26items[][quantity]=1%26return_to=/checkout",
          "Delivery every 3 months": "https://ecowisevitamins.com/cart/clear?return_to=/cart/add?items[][id]=50795719852320%26items[][quantity]=1%26items[][selling_plan]=5621612832%26items[][id]=50795724865824%26items[][quantity]=1%26return_to=/checkout"
        }
      }
    };
  
    function updateUI(tub, productType, delivery = "Delivery every 1 month") {
      const id = tub.getAttribute('data-tub');
      const c = config[id];
      if (!c) return;
  
      // Базовые цены
      productBlock.querySelector('.buy-product__old-price').innerText = c.old;
      productBlock.querySelector('.buy-product__price').innerText = c.price;
      productBlock.querySelector('.buy-product__old-price--autoship').innerText = c.autoOld;
      productBlock.querySelector('.buy-product__price--autoship').innerText = c.autoPrice;
    //   productBlock.querySelector('.list-price').innerText = c.listPrice;
    //   productBlock.querySelector('.final-price').innerText = productType.classList.contains('buy-product-type__second') ? c.autoPrice : c.price;
  
      // Savings
      tub.querySelector('.buy-product-tub__each').innerText = productType.classList.contains('buy-product-type__second') ? c.saveSub : c.saveOneTime;
  
      // Btn href
      btn.href = productType.classList.contains('buy-product-type__second') ? c.hrefSub[delivery] : c.hrefOneTime;
  
      // Trigger text
      trigger.querySelector('p').innerText = delivery;
    }
  
    // События
    tubs.forEach(tub => {
      tub.addEventListener('click', () => {
        tubs.forEach(t => t.classList.remove('active'));
        tub.classList.add('active');
        const activeType = productBlock.querySelector('.buy-product-type.active') || productTypes[0];
        const delivery = trigger.querySelector('p').innerText;
        updateUI(tub, activeType, delivery);
      });
    });
  
    productTypes.forEach(pt => {
      pt.addEventListener('click', () => {
        productTypes.forEach(p => p.classList.remove('active'));
        pt.classList.add('active');
        const activeTub = productBlock.querySelector('.buy-product-tub.active') || tubs[0];
        const delivery = trigger.querySelector('p').innerText;
        updateUI(activeTub, pt, delivery);
      });
    });
  
    trigger.addEventListener('click', () => {
      items.style.display = items.style.display === 'block' ? 'none' : 'block';
    });
  
    selectItems.forEach(item => {
      item.addEventListener('click', () => {
        selectItems.forEach(i => i.classList.remove('active'));
        item.classList.add('active');
        const text = item.querySelector('p').textContent;
        trigger.querySelector('p').textContent = text;
        const activeTub = productBlock.querySelector('.buy-product-tub.active') || tubs[0];
        const activeType = productBlock.querySelector('.buy-product-type.active') || productTypes[0];
        updateUI(activeTub, activeType, text);
        items.style.display = 'none';
      });
    });
  
    // Инициализация
    tubs[0].click();
  });
  